var React = require('react');

function Delete2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-1665 -975)"},React.createElement("g",{"transform":"translate(1664 973.75)"},[React.createElement("path",{"d":"M13.061,13.993l1.768,1.768-1.061,1.061L12,15.053l-1.768,1.768L9.172,15.76l1.768-1.768L9.172,12.225l1.061-1.061L12,12.932l1.768-1.768,1.061,1.061Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M16.75,2.25H7.25v4H3v1.5H5.25v14h13.5v-14H21V6.25H16.75Zm-1.5,4V3.75H8.75v2.5Zm-8.5,1.5v12.5h10.5V7.75Z","fillRule":"evenodd","fill":"currentColor","key":1})])));
}

Delete2.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Delete2;

Delete2.default = Delete2;
